import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  inputTitle: {
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  inputDescription: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  statusList: {
    display: 'flex',
    flexDirection: 'row',
    '& button': {
      marginRight: 4,
    },
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  tooltip: {
    fontSize: '1rem',
    lineHeight: '150%',
  },
  verdictIcon: {
    marginLeft: 24,
    display: 'inline-flex',
    alignItems: 'self-end',
    fontSize: 12,
    position: 'relative',
    top: 4,
    '& > svg': {
      marginRight: theme.spacing(1),
    },
  },
  table: {
    marginBottom: theme.spacing(3),
  },
}));

const ProjectPreviewOpinions = ({ opinions }) => {
  const classes = useStyles();
  const theme = useTheme();

  const verdictLabelColor = (verdictLabel) => {
    switch (verdictLabel) {
      case 'Do poprawy':
        return (
          <span
            className={classes.verdictIcon}
            style={{ color: theme.palette.primary.main }}
          >
            <HighlightOffIcon />
            {verdictLabel}
          </span>
        );
      case 'Negatywna':
      case 'Odrzucenie':
        return (
          <span
            className={classes.verdictIcon}
            style={{ color: theme.palette.opinionStatus.failed }}
          >
            <ErrorOutlineIcon />
            {verdictLabel}
          </span>
        );
      default:
        return (
          <span
            className={classes.verdictIcon}
            style={{ color: theme.palette.opinionStatus.success }}
          >
            <CheckCircleOutlineIcon />
            {verdictLabel}
          </span>
        );
    }
  };

  return (
    <>
      {Object.keys(opinions?.final_opinion ?? {}).length > 0 && (
        <>
          <Typography variant='h6' className={classes.title}>
            Opinia finalna
            {opinions?.final_opinion.verdict &&
              verdictLabelColor(opinions?.final_opinion.verdict)}
          </Typography>
          <Typography color='textSecondary' className={classes.title}>
            {opinions?.final_opinion.content}
          </Typography>
        </>
      )}
      {(isProfilePreview ||
        ['Negatywna', 'Odrzucenie', 'Pozytywna', 'Zatwierdzenie'].includes(
          opinions?.formal_opinion.verdict,
        )) &&
        Object.keys(opinions?.formal_opinion ?? {}).length > 0 && (
          <>
            <Typography variant='h6' className={classes.title}>
              Opinia formalna
              {opinions?.formal_opinion.verdict &&
                verdictLabelColor(opinions?.formal_opinion.verdict)}
            </Typography>
            <Typography color='textSecondary' className={classes.title}>
              {opinions?.formal_opinion?.content}
            </Typography>
          </>
        )}
        {Object.keys(opinions?.formal_opinion ?? {}).length < 1 &&
          Object.keys(opinions?.final_opinion ?? {}).length < 1 &&
          <>
            <Typography variant='h6' className={classes.title}>
              Projekt nie został jeszcze oceniony
            </Typography>
            <Typography color='textSecondary' className={classes.title}>
              Ocena projektu pojawi się w momencie publikacji projektów przez urząd.
            </Typography>
          </>
        }
    </>
  );
};

ProjectPreviewOpinions.propTypes = {
  opinions: PropTypes.object.isRequired,
};


export default ProjectPreviewOpinions;
